module.exports = __webpack_public_path__ + "static/media/cross-training.98a10c19.jpg";